"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReceipt = void 0;
const tools_1 = require("@axiom-crypto/tools");
const halo2_lib_js_1 = require("@axiom-crypto/halo2-lib-js");
const utils_1 = require("../utils");
const data_1 = require("./data");
var SpecialReceiptField;
(function (SpecialReceiptField) {
    SpecialReceiptField[SpecialReceiptField["TxType"] = 51] = "TxType";
    SpecialReceiptField[SpecialReceiptField["BlockNumber"] = 52] = "BlockNumber";
    SpecialReceiptField[SpecialReceiptField["TxIdx"] = 53] = "TxIdx";
})(SpecialReceiptField || (SpecialReceiptField = {}));
;
const buildReceipt = (blockNumber, txIdx) => {
    const getSubquery = (fieldOrLog, topicOrData, eventSchema) => {
        let receiptSubquery = {
            blockNumber: blockNumber.number(),
            txIdx: txIdx.number(),
            fieldOrLogIdx: fieldOrLog.number(),
            topicOrDataOrAddressIdx: topicOrData.number(),
            eventSchema: eventSchema.hex(),
        };
        const dataSubquery = { subqueryData: receiptSubquery, type: tools_1.DataSubqueryType.Receipt };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, txIdx, fieldOrLog, topicOrData, eventSchema.hi(), eventSchema.lo()]);
    };
    const log = (logIdx) => {
        if (typeof logIdx === "string" || typeof logIdx === "number" || typeof logIdx == "bigint") {
            logIdx = (0, utils_1.getCircuitValueConstant)(logIdx);
        }
        const logIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(logIdx, tools_1.AxiomV2FieldConstant.Receipt.LogIdxOffset);
        const topic = (topicIdx, eventSchema) => {
            if (typeof eventSchema === "string") {
                eventSchema = (0, utils_1.getCircuitValue256Constant)(eventSchema);
            }
            if (eventSchema === undefined) {
                eventSchema = (0, utils_1.getCircuitValue256Constant)(0);
            }
            if (typeof topicIdx === "string" || typeof topicIdx === "number" || typeof topicIdx == "bigint") {
                topicIdx = (0, utils_1.getCircuitValueConstant)(topicIdx);
            }
            return getSubquery(logIdxProcessed, topicIdx, eventSchema);
        };
        const address = async () => {
            const topicOrDataIdx = (0, utils_1.getCircuitValueConstant)(tools_1.AxiomV2FieldConstant.Receipt.AddressIdx);
            return getSubquery(logIdxProcessed, topicOrDataIdx, (0, utils_1.getCircuitValue256Constant)(0));
        };
        const data = async (dataIdx, eventSchema) => {
            if (typeof dataIdx === "string" || typeof dataIdx === "number" || typeof dataIdx == "bigint") {
                dataIdx = (0, utils_1.getCircuitValueConstant)(dataIdx);
            }
            if (eventSchema === undefined) {
                eventSchema = (0, utils_1.getCircuitValue256Constant)(0);
            }
            if (typeof eventSchema === "string") {
                eventSchema = (0, utils_1.getCircuitValue256Constant)(eventSchema);
            }
            const dataIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(dataIdx, tools_1.AxiomV2FieldConstant.Receipt.DataIdxOffset);
            return getSubquery(logIdxProcessed, dataIdxProcessed, eventSchema);
        };
        return Object.freeze({
            topic,
            address,
            data
        });
    };
    const functions = Object.fromEntries(Object.keys(tools_1.ReceiptField).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const receiptField = (0, utils_1.getCircuitValueConstant)(tools_1.ReceiptField[key]);
                const zero = (0, utils_1.getCircuitValueConstant)(0);
                const zeroCircuitValue256 = (0, utils_1.getCircuitValue256Constant)(0);
                return getSubquery(receiptField, zero, zeroCircuitValue256);
            }];
    }));
    const specialFunctions = Object.fromEntries(Object.keys(SpecialReceiptField).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const receiptField = (0, utils_1.getCircuitValueConstant)(SpecialReceiptField[key]);
                const zero = (0, utils_1.getCircuitValueConstant)(0);
                const zeroCircuitValue256 = (0, utils_1.getCircuitValue256Constant)(0);
                return getSubquery(receiptField, zero, zeroCircuitValue256);
            }];
    }));
    const logsBloom = async (logsBloomIdxRaw) => {
        if (logsBloomIdxRaw instanceof halo2_lib_js_1.CircuitValue) {
            throw new Error("logsBloomIdxRaw must be a constant (not a CircuitValue)");
        }
        const logsBloomIdx = (0, utils_1.getCircuitValueConstant)(logsBloomIdxRaw);
        if (logsBloomIdx.number() < 0 || logsBloomIdx.number() >= 8) {
            throw new Error("logsBloomIdx range is [0,8)");
        }
        const logIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(logsBloomIdx, tools_1.AxiomV2FieldConstant.Receipt.LogsBloomIdxOffset);
        const zero = (0, utils_1.getCircuitValueConstant)(0);
        const zeroCircuitValue256 = (0, utils_1.getCircuitValue256Constant)(0);
        return getSubquery(logIdxProcessed, zero, zeroCircuitValue256);
    };
    const receipt = {
        ...functions,
        ...specialFunctions,
        log,
        logsBloom
    };
    return Object.freeze(receipt);
};
exports.buildReceipt = buildReceipt;
//# sourceMappingURL=receipt.js.map